import { render } from "./UserAuth.vue?vue&type=template&id=32d3a62a&scoped=true"
import script from "./UserAuth.vue?vue&type=script&lang=js"
export * from "./UserAuth.vue?vue&type=script&lang=js"

import "./UserAuth.vue?vue&type=style&index=0&id=32d3a62a&scoped=true&lang=css"

import exportComponent from "/Users/michaelp/Library/CloudStorage/OneDrive-個人/Visual Studio/Vue Complete/auth-09-adding-auto-login/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d3a62a"]])

export default __exports__